import { returnCreation } from './return-creation-de.i18n';

export const de = {
  returnCreation,
};
